const preloadWidget = async (row, funcionalidade, authorization, activeAttendance) => {
  const payload = {
    textoPuro: row.textoPuro || '',
    titulo: `Informações do Plano: ${row.titulo}`
  }
  return createPayload(payload, funcionalidade, authorization, activeAttendance)
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.id,
    'data': { ...detalhe },
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': true
    })
  }

  payload.opcoesDeEnvio.push({
    'nome': detalhe.titulo,
    'nomeIntegracao': '',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {},
      'payload': {}
    },
    'data': {
      'tituloWidget': funcionalidade.parametros.textos.tituloTelaDetalhePINSS,
      'textoPINSS': detalhe.textoPuro
    }
  })
  return payload
}
export { preloadWidget }
